<template>
  <div class="spinner spinner-track spinner-primary spinner-lg mr-15">
  </div>
</template>

<script>
export default {
    name: "Loader.vue",
}
</script>

<style scoped>
 .spinner{
    position: fixed;
    left: 50%;
    top: 50%;
    bottom: 50%;
    right: 50%;
    display: grid;
    place-items: center;
    z-index: 111;
   }
.spinner.spinner-track.spinner-primary:before{
    width: 40px;
    height: 40px;
    border: 3px solid #7e8299;
    border-top-color: #b5b5c3;
}
</style>
